import * as React from 'react';
import {TscButtonType, AlertModal} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import * as ReactDOM from 'react-dom';

export default class DeleteCommentModal extends React.Component<DeleteCommentModalProps, {}> {
   constructor(props: DeleteCommentModalProps) {
      super(props);
   }

   render() {
      const {onCancelDeletion, onPerformDeletion, saving, alertContent} = this.props;
      return ReactDOM.createPortal(
         <div className="delete-comment-modal-container">
            <AlertModal title={Strings.labels.deleteComment}
                        onClose={onCancelDeletion}
                        closeContent={Strings.labels.cancel}
                        onConfirm={onPerformDeletion}
                        confirmContent={Strings.labels.delete}
                        confirmButtonType={TscButtonType.destructive}
                        onDismiss={onCancelDeletion}
                        dismissContent={Strings.labels.cancel}
                        hideButtons={saving}
                        testId="delete-comment-alert">
               {alertContent}
            </AlertModal>
         </div>,
         document.getElementById('review-container'));
   }
}

export interface DeleteCommentModalProps {
   alertContent: JSX.Element;
   saving: boolean;
   onCancelDeletion(): void;
   onPerformDeletion(): void;
}
